export const ENV = process.env.REACT_APP_ENV;

export const RIDGE_API = process.env.REACT_APP_RIDGE_API;
export const SARBJIT_API = process.env.REACT_APP_SARBJIT_API;

export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;
export const TOKEN_NAME = process.env.REACT_APP_TOKEN_NAME;

export const Url = process.env.REACT_APP_SITE_URL;
export const ReturnUrl = process.env.REACT_APP_RETURN_URL;
export const ReturnUrl_SubscriptionSigning = process.env.REACT_APP_RETURN_URL_SUBSCRIPTION;